const PERMISSION_KEY= "core:tenant_user_mapping";
const PAGE_URL = {
    TENANT_USER_MAPPING_PAGE: "/admin/core/tenant-user-mapping"
}

export {PERMISSION_KEY, PAGE_URL}

